import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import React, { useContext, useState } from "react";
import axiosClient from "../Utils/axiosClient";
import useTitle from "../Hooks/useTitle";
import { useTranslation } from "react-i18next";
import ToastContext from "../Context/toastContext";
import {
  MaskedTextBoxComponent,
  TextAreaComponent,
  TextBoxComponent,
} from "@syncfusion/ej2-react-inputs";

const ContactUsPage = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  const [message, setMessage] = useState("");

  const { t } = useTranslation();
  const { showToast } = useContext(ToastContext);

  useTitle(`${t("Contact Us")} | Netileti`);

  const onSubmit = async (event) => {
    event.preventDefault();

    const unmaskedPhoneNumber = phoneNumber.replace(/\D/g, "");

    const payload = {
      email,
      phoneNumber: unmaskedPhoneNumber,
      messageContent: message,
    };

    try {
      const response = await axiosClient.post(`/contactus`, payload);

      if (response.status === 200) {
        showToast(`${t("Registration!")}`, `${t("Success")}`);
        setMessage("");
        setEmail("");
        setPhoneNumber("");
      } else {
        showToast(
          `${t("Error")}: ${response.statusText}`,
          "Http status :",
          response.status
        );
      }
    } catch (error) {
      showToast(
        `${t("Failed to send message. Please try again")}. ${
          error.response.data
        }`,
        `${t("Error")}`
      );
    }
  };

  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div className="control-wrapper">
        <form id="contact-us" onSubmit={onSubmit}>
          <MaskedTextBoxComponent
            mask={"+00 (000)-000-0000"}
            placeholder={t("Phone Number")}
            value={phoneNumber}
            maskedValue={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            onValueChange={(e) => setPhoneNumber(e.target.value)}
            onBlur={(e) => setPhoneNumber(e.target.value)}
            required
          />
          <TextBoxComponent
            placeholder={t("E-mail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            type="email"
          />
          <TextAreaComponent
            id="input-message"
            className="e-input"
            type="text"
            placeholder={t("Message")}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            resizeMode="None"
            rows={3}
          />
          <ButtonComponent cssClass="e-primary e-outline" type="submit">
            {t("Submit")}
          </ButtonComponent>
          <div className="logo-container">
            <img className="logo" src="/images/logo.png" alt="login-sm" />
            <img
              className="olimpuslogo"
              src="/images/olimpuslogo.png"
              alt="login-sm"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUsPage;
